import { isNil } from '@develop/ia-utils'

/**
 *
 * @example
 * product:07160474
 * product:07160474:with_additional_details
 * product:07160474:2163
 * product:07160474:2163:with_additional_details
 */
export const constructProductKey = (props: { pzn: string; pharmacyId?: string | number; additionalDetails?: boolean }) => {
  const { pzn, pharmacyId, additionalDetails } = props

  const base = ['product', pzn]

  if (additionalDetails) {
    base.push('additional_details')
  } else {
    if (!isNil(pharmacyId)) {
      base.push(pharmacyId.toString())
    }
  }

  return base.join(':')
}
